module.exports = __webpack_public_path__ + "assets/img/34_888.565512af.jpg";